var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"linkedin-rect","d":"M5.465.009A5.475,5.475,0,0,0,.007,5.468V22.406a5.474,5.474,0,0,0,5.459,5.457H22.4a5.473,5.473,0,0,0,5.457-5.457V5.468A5.475,5.475,0,0,0,22.4.009Zm1.373,4.6A2.193,2.193,0,1,1,6.81,8.978H6.783a2.192,2.192,0,1,1,.055-4.373Zm12.4,5.8c2.768,0,4.843,1.809,4.843,5.7v7.258H19.878V16.594c0-1.7-.608-2.863-2.131-2.863a2.3,2.3,0,0,0-2.159,1.538,2.872,2.872,0,0,0-.139,1.026v7.069H11.242s.055-11.47,0-12.658h4.207V12.5a4.176,4.176,0,0,1,3.791-2.089Zm-14.534.3H8.914V23.365H4.707V10.708Z","transform":"translate(-0.007 -0.009)"}));
}

Linkedin.defaultProps = {"width":"27.855","height":"27.854","viewBox":"0 0 27.855 27.854"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
